var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAssignTeam = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-tag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 18.9583C9.41667 18.9583 8.825 18.7333 8.38333 18.2917L6.95831 16.8833C6.60831 16.5333 6.12501 16.3417 5.63334 16.3417H5C3.275 16.3417 1.875 14.95 1.875 13.2417V4.14998C1.875 2.44165 3.275 1.05001 5 1.05001H15C16.725 1.05001 18.125 2.44165 18.125 4.14998V13.2417C18.125 14.95 16.725 16.3417 15 16.3417H14.3667C13.875 16.3417 13.3917 16.5417 13.0417 16.8833L11.6167 18.2917C11.175 18.7333 10.5833 18.9583 10 18.9583ZM5 2.29167C3.96667 2.29167 3.125 3.12497 3.125 4.14164V13.2333C3.125 14.2583 3.96667 15.0833 5 15.0833H5.63334C6.45834 15.0833 7.25831 15.4167 7.84164 15.9917L9.26666 17.4C9.675 17.8 10.3333 17.8 10.7417 17.4L12.1666 15.9917C12.75 15.4167 13.55 15.0833 14.375 15.0833H15C16.0333 15.0833 16.875 14.25 16.875 13.2333V4.14164C16.875 3.11664 16.0333 2.29167 15 2.29167H5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99995 8.95838C8.58328 8.95838 7.43327 7.80837 7.43327 6.3917C7.43327 4.97504 8.58328 3.82507 9.99995 3.82507C11.4166 3.82507 12.5666 4.97504 12.5666 6.3917C12.5666 7.80837 11.4166 8.95838 9.99995 8.95838ZM9.99995 5.07507C9.27495 5.07507 8.68327 5.6667 8.68327 6.3917C8.68327 7.1167 9.27495 7.70838 9.99995 7.70838C10.7249 7.70838 11.3166 7.1167 11.3166 6.3917C11.3166 5.6667 10.7249 5.07507 9.99995 5.07507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3333 13.6751C12.9917 13.6751 12.7083 13.3917 12.7083 13.0501C12.7083 11.9001 11.4917 10.9585 10 10.9585C8.50833 10.9585 7.29167 11.9001 7.29167 13.0501C7.29167 13.3917 7.00833 13.6751 6.66667 13.6751C6.325 13.6751 6.04167 13.3917 6.04167 13.0501C6.04167 11.2084 7.81667 9.70845 10 9.70845C12.1833 9.70845 13.9583 11.2084 13.9583 13.0501C13.9583 13.3917 13.675 13.6751 13.3333 13.6751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAssignTeam);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/assign-team.f0230a935b71ec651381e6683547a534.svg";